import React from 'react'

import SwitchingSpecial from './SwitchingSpecial'

// import * as firebase from 'firebase'
// require("firebase/firestore")

class SwitchingSpecialContainer extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            // champObject: props.champObject,
            // idOfSwitching: props.idOfSwitching,
            switchingList: [],

            roundOf32Competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            roundOf16Competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            quarterFinalsCompetitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            semiFinalsCompetitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            finalCompetitors: [{ nome: '' }, { nome: '' }],

            /* Array to create divs that draws the line between switching */
            arrayForLines00: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
            arrayForLines01: [1, 2, 3, 4, 5, 6, 7, 8],
            arrayForLines02: [1, 2, 3, 4],
            arrayForLines03: [1, 2],
            arrayForLines04: [1],

            champion: ''
        }
    }

    componentDidMount = () => {
        // this.componentWillReceiveProps(this.props)

        /* Create array of switching list */
        let localArrayOfswitching = []
        for (let i = 0; i < 10; i++) {
            localArrayOfswitching.push(i)
        }
        this.setState({
            switchingList: localArrayOfswitching
        })

        /* Clear all confrontations */
        this.setState({
            roundOf32Competitors: [{ nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }, { nome: '' }],
            roundOf16Competitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            quarterFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }, { nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            semiFinalsCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: true }, { nome: '', colunaUm: false }, { nome: '', colunaUm: false }],
            finalCompetitors: [{ nome: '', colunaUm: true }, { nome: '', colunaUm: false }]
        })

        /* Get all confrontations and info */
        let switching = this.props.switching;

        /* Get confrontations */
        if (switching.roundOf32)
            this.setState({ roundOf32Competitors: switching.roundOf32 })
        if (switching.roundOf16)
            this.setState({ roundOf16Competitors: switching.roundOf16 })
        if (switching.quarterFinals !== undefined)
            this.setState({ quarterFinalsCompetitors: switching.quarterFinals })
        if (switching.semiFinals !== undefined)
            this.setState({ semiFinalsCompetitors: switching.semiFinals })
        if (switching.final !== undefined) {
            this.setState({ finalCompetitors: switching.final })
            if (switching.final[0].hasWon && switching.final[0].hasWon !== undefined)
                this.setState({ champion: switching.final[0].nome })
            else if (!switching.final[0].hasWon && switching.final[0].hasWon !== undefined)
                this.setState({ champion: switching.final[1].nome })
        }

        /* Get teams with score */
        if (switching.arrayOfTeams !== undefined)
            this.setState({ arrayOfTeamsWithScore: switching.arrayOfTeams })

        /* Get info */
        this.setState({
            studentSexo: switching.sexo,
            studentFaixa: switching.faixa,
            studentPeso: switching.peso,
            studentIdade: switching.idade
        });
    }

    // componentWillReceiveProps = (nextProps) => {
    //     /* Open Loading Icon */
    //     if(document.getElementById('loadingSpecialSwitching') !== null)
    //         document.getElementById('loadingSpecialSwitching').style.display = 'block'

    //     /* Create array of switching list */
    //     let localArrayOfswitching = []
    //     for(let i = 0; i < 10; i++){
    //         localArrayOfswitching.push(i)
    //     }
    //     this.setState({
    //         switchingList: localArrayOfswitching
    //     })

    //     /* Clear all confrontations */
    //     this.setState({
    //         roundOf32Competitors: [{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''}],
    //         roundOf16Competitors: [{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''}],
    //         quarterFinalsCompetitors: [{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''},{nome:''}],
    //         semiFinalsCompetitors: [{nome:''},{nome:''},{nome:''},{nome:''}],
    //         finalCompetitors: [{nome:''},{nome:''}],
    //     })

    //     /* Firestore */
    //     /* Get all confrontations and info */
    //     if(nextProps.idOfSwitching !== undefined){
    //         /*firebase.firestore().collection('champs').doc(this.state.champObject.__key).collection('switching').doc(this.state.idOfSwitching.toString()).get()*/
    //         firebase.database().ref('champs/' + nextProps.champObject.__key + '/switching/' + nextProps.idOfSwitching.toString()).once('value')
    //         .then(switching => {
    //             if(switching.val()){

    //                 /* Get confrontations */
    //                 if(switching.val().roundOf32)
    //                     this.setState({ roundOf32Competitors: switching.val().roundOf32 })
    //                 if(switching.val().roundOf16)
    //                     this.setState({ roundOf16Competitors: switching.val().roundOf16 })
    //                 if(switching.val().quarterFinals)
    //                     this.setState({ quarterFinalsCompetitors: switching.val().quarterFinals })
    //                 if(switching.val().semiFinals)
    //                     this.setState({ semiFinalsCompetitors: switching.val().semiFinals })
    //                 if(switching.val().final){
    //                     this.setState({ finalCompetitors: switching.val().final })
    //                     if(switching.val().final[0].hasWon)
    //                         this.setState({ champion: switching.val().final[0] })
    //                     else if(!switching.val().final[0].hasWon)
    //                         this.setState({ champion: switching.val().final[1] })
    //                 }

    //                 /* Get teams with score */
    //                 if(switching.val().arrayOfTeams)
    //                     this.setState({ arrayOfTeamsWithScore: switching.val().arrayOfTeams })

    //                 /* Get info */
    //                 this.setState({
    //                     studentSexo: switching.val().sexo,
    //                     studentFaixa: switching.val().faixa,
    //                     studentPeso: switching.val().peso,
    //                     studentIdade: switching.val().idade
    //                 })
    //             }
    //         })
    //         .then(() => {
    //             /* Close Loading Icon */
    //             if(document.getElementById('loadingSpecialSwitching'))
    //                 document.getElementById('loadingSpecialSwitching').style.display = 'none'
    //         })
    //     }
    // }

    render() {

        return (
            <SwitchingSpecial
                roundOf32Competitors={this.state.roundOf32Competitors}
                arrayForLines00={this.state.arrayForLines00}
                roundOf16Competitors={this.state.roundOf16Competitors}
                arrayForLines01={this.state.arrayForLines01}
                quarterFinalsCompetitors={this.state.quarterFinalsCompetitors}
                arrayForLines02={this.state.arrayForLines02}
                semiFinalsCompetitors={this.state.semiFinalsCompetitors}
                arrayForLines03={this.state.arrayForLines03}
                finalCompetitors={this.state.finalCompetitors}
                arrayForLines04={this.state.arrayForLines04}
                champion={this.state.champion}
            />
        )
    }
}

export default SwitchingSpecialContainer